const mapping: Record<string, string> = {
  id: 'c=>c.Id',
  key: 'c=>c.Key',
  type: 'c=>c.Type',
}

export const mapSortDynamicPropertyDefinitionParams = (key: string) =>
  mapping[key]
